/*
 * ProjectActivityListPage Messages
 *
 * This contains all the text for the ProjectsPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.publications';

export default defineMessages({
  content: {
    id: `${scope}.content`,
    defaultMessage: 'Content',
  },
  defaultProjectName: {
    id: `${scope}.default.projectName`,
    defaultMessage: 'Untitled activity',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'NAME',
  },
  author: {
    id: `${scope}.name`,
    defaultMessage: 'AUTHOR',
  },
  owner: {
    id: `${scope}.owner`,
    defaultMessage: 'PUBLISHED BY',
  },
  updatedAt: {
    id: `${scope}.updatedAt`,
    defaultMessage: 'Last Modified',
  },
  publish: {
    id: `${scope}.publish`,
    defaultMessage: 'PUBLISH',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'STATUS',
  },
  unknown: {
    id: `${scope}.unknown`,
    defaultMessage: 'Unknown',
  },
  publicationVersion: {
    id: `${scope}.status`,
    defaultMessage: 'Publications versions',
  },
  EPUB_ETEXT: {
    id: `${scope}.ePub`,
    defaultMessage: 'Pearson+ ePub',
  },
  EPUB_CHANNEL_PARTNER: {
    id: `${scope}.channelPartner`,
    defaultMessage: 'Channel Partner ePub',
  },
  BRONTE_CLASSES_ON_DEMAND: {
    id: `${scope}.classOnDemand`,
    defaultMessage: 'Class on Demand',
  },
  BRONTE_PEARSON_PLUS: {
    id: `${scope}.pearsonPlus`,
    defaultMessage: 'Pearson+ Bronte Viewer',
  },
  BRONTE_PEARSON_PLUS_TEST_ONLY: {
    id: `${scope}.bvTestOnly`,
    defaultMessage: 'BV-Test Only',
  },
  PEARSON: {
    id: `${scope}.pearson`,
    defaultMessage: 'Pearson',
  },
  IN_DESIGN: {
    id: `${scope}.InDesign`,
    defaultMessage: 'InDesign',
  },
  ALREADY_IN_PROGRESS: {
    id: `${scope}.ALREADY_IN_PROGRESS`,
    defaultMessage: 'Publication already in progress',
  },
  favorites: {
    id: `${scope}.favorites`,
    defaultMessage: 'Favorites',
  },
  addFavorites: {
    id: `${scope}.addFavorites`,
    defaultMessage: 'No favorites added',
  },
  allPublications: {
    id: `${scope}.allPublications`,
    defaultMessage: 'All publications',
  },
});
